@if (logoTitle) {
    <div class="marketsubtype-logo-button">
        <ds-badge class="marketsubtype-logo-badge" size="medium" [variant]="badgeVariant || 'primary'" [inverse]="false">
            {{ logoTitle }}
        </ds-badge>

        <button
            ds-button-icon
            variant="flat-reduced"
            kind="tertiary"
            size="small"
            [dsTooltipTriggerFor]="tooltipTemplate"
            [position]="tooltipPlacement || 'bottom'"
            [arrowPosition]="arrowPosition || 'end'"
            [closeOnScroll]="true"
            [fullWidth]="true"
            [closeOutsideViewport]="true"
            [closeOnInteraction]="true"
            [tooltipToggle]="true"
            (tooltipToggleChange)="toggleTooltip($event)">
            <vn-icon aria-hidden="true" size="12" [name]="tooltip.showTooltip ? 'theme-info-i' : 'theme-info'" />
        </button>
        <ng-template #tooltipTemplate>
            <ds-tooltip-content
                class="marketsubtype-logo-tooltip"
                variant="utility"
                inverse="false"
                fullWidthMode="fullwidthMargin"
                [fullWidth]="true">
                <button slot="close" ds-button-icon dsTooltipClose variant="flat" size="small" kind="tertiary" [inverse]="true">
                    <vn-icon size="12" name="theme-close-small" />
                </button>
                <div slot="description">
                    <div [innerHTML]="tooltip.message"></div>
                    <div [innerHTML]="tooltip.linkText" (click)="onTooltipLinkClick()"></div>
                </div>
            </ds-tooltip-content>
        </ng-template>
    </div>
}
